
export default {
  // Navigation-related translations
  "home": "Home",
  "profile": "Profile",
  "airports": "Airports",
  "inventory": "Inventory",
  "admin": "Admin",
  "regions": "Regions",
  "airport": "Airport",
  "location": "Location",
  "average_score": "Average Score",
  "total_reviews": "Total Reviews",
  "rank": "Rank",
  "hand_check_success": "Hand Check Success",
  "no_airports_found": "No airports found in this region",
  "resources": "Resources",
  "develop": "Develop",
  "sign_in": "Sign In",
  "sign_up": "Sign Up",
  // "light_meter": "Light Meter", // Commented out to hide from navigation
};
